"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M33 14h-9V1.385a.482.482 0 0 0-.481-.5H23.5a.49.49 0 0 0-.35.147L1.091 23.146a.5.5 0 0 0 .354.854h8.838a7.964 7.964 0 0 0 14.607 6H33a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1zM4.828 22L22 4.828V14h-3a1 1 0 0 0-1 1v3a7.966 7.966 0 0 0-6.891 4zM18 32a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6z" })
);

